import React, { useState, useEffect } from "react";
import useAuth from "../../auth/useAuth";
import { generateWorkoutService } from "./generatorService";
import WorkoutPlan from "./generatorResults";
import WorkoutView from "./generatorView";
import WorkoutGeneratorHelp from "./generatorHelp";
import HelpIcon from '@mui/icons-material/Help';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

const WorkoutGenerator = () => {
  const { isAuthenticated, username, redirectToAuth, loading } = useAuth();
  const [fitnessLevel, setFitnessLevel] = useState([]);
  const [focusArea, setFocusArea] = useState([]);
  const [equipment, setEquipment] = useState([]);
  const [injuries, setInjuries] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(null); 
  const [workoutReturnPlan, setWorkoutPlan] = useState(null);
  const [helpOpen, setHelpOpen] = useState(false);

  const [buttonText, setButtonText] = useState("Generate Workout");
  const [isButtonDisabled, setButtonDisabled] = useState(false);

  useEffect(() => {
  }, [isAuthenticated, username, loading]);


  // Toggle dropdown and log actions
  const toggleDropdown = (category) => {
    console.log("Toggling dropdown:", category);
    setOpenDropdown((prev) => (prev === category ? null : category));
  };

  // Handle selection and log changes
  const handleSelection = (type, value) => {

    const updateSelection = (currentItems, setValue) => {
      if (currentItems.includes(value)) {
        // console.log(`Removing ${value} from ${type}`);
        setValue(currentItems.filter((item) => item !== value));
      } else {
        // console.log(`Adding ${value} to ${type}`);
        setValue([...currentItems, value]);
      }
    };

    switch (type) {
      case "fitness":
        updateSelection(fitnessLevel, setFitnessLevel);
        break;
      case "focus":
        updateSelection(focusArea, setFocusArea);
        break;
      case "equipment":
        updateSelection(equipment, setEquipment);
        break;
      case "injuries":
        updateSelection(injuries, setInjuries);
        break;
      default:
        console.error(`Unknown selection type: ${type}`);
        break;
    }
  };

  // Redirect if not authenticated
  useEffect(() => {
    if (!loading && !isAuthenticated) {
      console.warn("User not authenticated. Redirecting...");
      redirectToAuth();
    }
  }, [isAuthenticated, loading, redirectToAuth]);

  const handleHelpOpen = () => setHelpOpen(true);
  const handleHelpClose = () => setHelpOpen(false);


  if (loading) {
    console.log("Loading state...");
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    console.warn("User is not authenticated.");
    return null;
  }

  const handleGenerateWorkout = async () => {
    try {
      const result = await generateWorkoutService(
        fitnessLevel,
        focusArea,
        equipment,
        injuries,
        setButtonText, 
        setButtonDisabled
      );
      setWorkoutPlan(result); 
      console.log('result', result);
    } catch (error) {
      console.error('Error generating workout:', error);
    }
  };

  return (
      <div className="section" id="genWorkView-container">
        {/* <div className="section"> */}
          <h2>Workout Generator</h2>
            <div className="list-section" style={{ position: "relative", padding: "14px", minHeight: "200px" }}>
                 <IconButton
                    onClick={handleHelpOpen}
                    aria-label="help"
                    style={{
                      position: "absolute",
                      top: 10,
                      right: 10,
                      color: "#67761F",
                    }}
                  >
                  <HelpIcon />
                </IconButton>
            <div className="list-container">

            <WorkoutView
  isAuthenticated={isAuthenticated}
  fitnessLevel={fitnessLevel}
  focusArea={focusArea}
  equipment={equipment}
  injuries={injuries}
  toggleDropdown={toggleDropdown}
  handleSelection={handleSelection}
  openDropdown={openDropdown}
/>

                {/* <WorkoutView
                  fitnessLevel={fitnessLevel}
                  focusArea={focusArea}
                  equipment={equipment}
                  injuries={injuries}
                  toggleDropdown={toggleDropdown}
                  handleSelection={handleSelection}
                  openDropdown={openDropdown} 
                  isAuthenticated={isAuthenticated}
                  loading={loading}
                /> */}
                  <button
                    id="generate-button"
                    onClick={handleGenerateWorkout}
                    disabled={isButtonDisabled}
                    className="btn-primary"
                  >
                    {buttonText}
                  </button>
                </div>

            </div>

          {workoutReturnPlan && <WorkoutPlan plan={workoutReturnPlan} />}

        <Dialog open={helpOpen} onClose={handleHelpClose} fullWidth maxWidth="md">
        <DialogTitle>
          Help - Workout Generator User Manual
          <IconButton
            aria-label="close"
            onClick={handleHelpClose}
            style={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <WorkoutGeneratorHelp />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default WorkoutGenerator;
